import React, { FC } from 'react';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useSpecificationsForKinds } from '../../../loaders/useSpecificationsForKinds';
import { KindGameEnvironmentIndex } from './KindGameEnvironmentIndex';
import { Route, Routes } from 'react-router';
import { useKindVersion } from '../../../loaders/useKindVersion';
import { PubRouteItems } from '../../routes';
import { matchDeeply, YoAlert } from '@yakoffice/shared-components';
import { useRootStore } from '../../../loaders/useRootStore';

export const KindIndex: FC = () => {

    const rootStore = useRootStore();
    const kindVersionResult = useKindVersion();
    const specificationsForKindsResult = useSpecificationsForKinds();

    return !kindVersionResult.isLoaded || !specificationsForKindsResult.isLoaded //|| !entitySelectionResult.isLoaded
        ? <CustomSpinner spinnerText="Loading kind and specifications..." />
        : kindVersionResult.kindVersion == null || rootStore.kindVersionStore.currentKindVersion == null ?
            <YoAlert text="Could not find kind version" icon={<i className="fas fa-file" />} />
            : <Routes>
                <Route path={matchDeeply(PubRouteItems.GameEnvironments, PubRouteItems.GameEnvironmentIdParam)}
                       element={<KindGameEnvironmentIndex />} />
            </Routes>;
};
